<template>
  <Page class="detailView">
    <div v-if="companyData">
      <div class="pageContent-title">企业信息</div>
      <div class="detailView-with-actions mt-5">
        <a-form class="flex-form" :form="form" :colon="false" labelAlign="left">
          <div class="form-base-width">
            <div>
              <a-form-item label="企业名称" required>
                <a-input
                  v-decorator="[
                    'companyName',
                    {
                      rules: [{ required: true, message: '请输入' }],
                    },
                  ]"
                  :disabled="isView"
                ></a-input>
              </a-form-item>
            </div>
            <div>
              <a-form-item label="登陆邮箱" required>
                <a-input
                  v-decorator="[
                    'contactEmail',
                    {
                      rules: [{ required: true, message: '请输入' }],
                    },
                  ]"
                  :disabled="isView"
                ></a-input>
              </a-form-item>
            </div>
            <div class="flex gap-6">
              <div class="flex gap-1">
                <a-form-item label="合作有效期" required>
                  <a-date-picker
                    v-decorator="[
                      'contractStartDate',
                      {
                        rules: [{ required: true, message: '请输入' }],
                      },
                    ]"
                    :disabledDate="disabledStartDate"
                    :disabled="isView"
                  >
                    <a-icon type="calendar" slot="suffixIcon"></a-icon>
                  </a-date-picker>
                </a-form-item>
                <div class="pt-2">~</div>
                <a-form-item>
                  <a-date-picker
                    v-decorator="[
                      'contractEndDate',
                      {
                        rules: [{ required: true, message: '请输入' }],
                      },
                    ]"
                    :disabledDate="disabledEndDate"
                    :disabled="isView"
                  >
                    <a-icon type="calendar" slot="suffixIcon"></a-icon>
                  </a-date-picker>
                </a-form-item>
              </div>

              <a-form-item label="合同状态" :labelCol="{ style: 'width:80px' }">
                <a-select
                  v-decorator="[
                    'contractStatus',
                    {
                      rules: [{ required: true, message: '请选择' }],
                    },
                  ]"
                  :disabled="isView"
                  :options="typesMap.contractStatus"
                  style="width: 120px"
                ></a-select>
              </a-form-item>
            </div>
            <a-form-item label="类型" required>
              <a-select
                class="w-full"
                v-decorator="['companyType', { initialValue: 1 }]"
                placeholder="请选择类型"
                allowClear
                :options="typesMap.companyType"
                :disabled="isView"
              ></a-select>
            </a-form-item>
            <a-form-item label="业务类型" required>
              {{
                form.getFieldValue('businessType') === 1 ?
                  '签证业务' : form.getFieldValue('businessType') === 2 ?
                    '公证业务' : form.getFieldValue('businessType') === 3 ?
                      '认证业务' : '公证业务'
              }}
            </a-form-item>
          </div>
          <div v-show="form.getFieldValue('companyType') === 2">
            <a-divider></a-divider>
            <div class="text-base font-bold">价格息配置</div>
            <div class="pl-7">
              <NotarProduct v-if="priceData" ref="notarProduct" :form-data="form" :companyData="priceData"></NotarProduct>
              <a-form-item label="结算周期" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:90px' }" requried>
                <div>
                  T+
                  <a-input-number
                    v-decorator="[
                      'notarizationProductSettlementPeriod',
                      {
                        rules: [
                          { required: true, message: '结算周期不能为空' }
                        ],
                      }
                    ]"
                    :precision="0"
                    :min="0"
                    :max="178"
                    style="width: 80px"
                    :disabled="isView"
                  ></a-input-number>
                  <span style="color:red;margin-left:20px">结算周期为0时，实际到账日期为1日后，需小于178天</span>
                </div>
              </a-form-item>
            </div>
            <a-divider></a-divider>
            
            <div class="text-base font-bold">地址配置</div>
            <div style="padding:0 30px;width:800px;border:1px solid #dfdfdf;padding-top:20px;margin-top:20px" class="form-base-width">
              <a-row :gutter="30">
                <a-col :span="12">
                  <a-form-item label="收件人" required>
                    <a-input
                      v-decorator="[
                        'person',
                        {
                          rules: [{ required: true, message: '请输入' }],
                        },
                      ]"
                      :disabled="isView"
                      placeholder="请输入收件人姓名"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="联系电话" required>
                    <a-input
                      v-decorator="[
                        'phoneNumber',
                        {
                          rules: [
                            { required: true, message: '请输入联系电话' },
                            { pattern: Reg.isMobile, message: '请输入正确的手机号' },
                          ],
                        },
                      ]"
                      placeholder="请填写手机号"
                      :disabled="isView"
                    ></a-input>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-form-item label="地址">
                <v-distpicker
                  @selected="selected"
                  :province="address.province"
                  :city="address.city"
                  :area="address.region"
                  :disabled="isView"
                  v-decorator="[
                    'region',
                    {
                      rules: [
                        { required: true, message: '请选择地址' }
                      ],
                    },
                  ]"
                ></v-distpicker>
              </a-form-item>
              <a-form-item label="详细信息">
                <a-input
                  v-decorator="[
                    'address',
                    {
                      rules: [{ required: true, message: '请输入详细信息' }],
                    },
                  ]"
                  placeholder="请填写详细地址"
                  :disabled="isView"
                ></a-input>
              </a-form-item>
            </div>
            <a-divider></a-divider>
          </div>
          <div class="form-base-width">
            <a-form-item label="联系人" required>
              <a-input
                v-decorator="[
                  'contactPerson',
                  {
                    rules: [{ required: true, message: '请输入' }],
                  },
                ]"
                :disabled="isView"
              ></a-input>
            </a-form-item>
            <a-form-item label="联系电话" required>
              <a-input
                v-decorator="[
                  'contactPhoneNumber',
                  {
                    rules: [
                      { required: true, message: '请输入' },
                      { pattern: Reg.isMobile, message: '请输入正确的手机号' },
                    ],
                  },
                ]"
                :disabled="isView"
              ></a-input>
            </a-form-item>
            <div class="relative">
              <a-form-item label="点券" class="relative flex items-center">
                <a-input v-decorator="['preDepositAmount']" disabled></a-input>
              </a-form-item>
              <a-button class="app-btn info-btn absolute top-1 -right-40" @click="checkConsumption">
                <app-icon type="icon-chakan"></app-icon>
                <span>查看消费记录</span>
              </a-button>
            </div>

            <a-form-item label="状态">
              <a-radio-group v-decorator="['isDisable']" :disabled="isView">
                <a-radio :value="0">已启用</a-radio>
                <a-radio :value="1">已禁用</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
        </a-form>
      </div>
      <div class="detailView-actions">
        <a-button class="app-btn" type="default" @click="back">取消</a-button>
        <a-button class="app-btn" type="primary" @click="doSave">保存</a-button>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import VDistpicker from '@/components/Distpicker/Distpicker'
import { toolMixin, queryViewMixin } from '@/utils/mixin'
import VisaProduct from './modules/VisaProduct.vue'
import NotarProduct from './modules/NotarProduct.vue'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
import { companyType } from '@/vars'
import Reg from '@/utils/reg'
export default {
  components: {
    Page,
    VDistpicker,
    VisaProduct,
    NotarProduct,
    PictureCardUpload,
  },
  props: {},
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      form: this.$form.createForm(this),
      // 结算modal
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '',
        data: {},
      },
      address: {
        province: '',
        city: '',
        region: ''
      },
      supplierId: null,
      companyData: null,
      priceData: null,
      Reg,
    }
  },
  computed: {
    typesMap() {
      return {
        companyType,
        contractStatus: [
          { value: 1, label: '未续约' },
          { value: 2, label: '存续' },
          { value: 3, label: '过期' },
        ],
        addressIsTure: [
          { value: 0, label: '未验证' },
          { value: 1, label: '已验证' },
        ],
        businessType: [
          { value: 1, label: '签证业务' },
          { value: 2, label: '公证业务' },
          { value: 3, label: '认证业务' },
        ]
      }
    },
    isView() {
      return this.$route.query.handleType === 'VIEW'
    },
  },
  methods: {
    selected(data) {
      this.address.province = data.province.value
      this.address.city = data.city.value
      this.address.region = data.area.value
    },
    disabledStartDate(currentDate) {
      const endDate = this.form.getFieldValue('contractEndDate')
      return endDate && currentDate.isAfter(endDate)
    },
    disabledEndDate(currentDate) {
      const startDate = this.form.getFieldValue('contractStartDate')
      return startDate && currentDate.isBefore(startDate)
    },
    checkConsumption() {
      window.open(`/m/scopeMain/recharge?companyId=${this.$route.query.companyId}`)
    },
    back() {
      this.$router.go(-1)
    },
    doSave() {
      if (this.address.region) {
        this.form.setFieldsValue({
          region: this.address.region
        })
      }
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          console.log('kankan')
          if (this.$refs.notarProduct.validateList()) {
            return
          }
          const params = values
          try {
            await this.$axios.post('/company/admin/company/save', {
              companyId: this.$route.query.companyId,
              userId: this.companyData.userId,
              ...params,
              contractEndDate: params.contractEndDate.format('YYYY-MM-DD'),
              contractStartDate: params.contractStartDate.format('YYYY-MM-DD'),
            })
            var obj = {
              baseId: this.priceData ? this.priceData.id : '',
              companyId: this.$route.query.companyId,
              notarizationPrice: params.notarizationPrice,
              duplicationPrice: params.duplicationPrice,
              servicePrice: params.servicePrice,
              expressPrice: params.expressPrice,
              ordinaryDuration: params.ordinaryDuration,
              urgentDuration: params.urgentDuration,
              superDuration: params.superDuration,
              moreInfoList: this.$refs.notarProduct.getList().map(v => {
                return {
                  ...v,
                  infoLanguage: JSON.stringify(v.infoLanguage)
                }
              })
            }
            await this.$axios.post('/company/admin/notarization/supplier/save', obj)
            var addressObj = {
              supplierId: this.supplierId,
              person: params.person,
              phoneNumber: params.phoneNumber,
              province: this.address.province,
              city: this.address.city,
              region: this.address.region,
              address: params.address,
            }
            await this.$axios.post('/company/admin/supplier/saveExpressAddress', addressObj)
            this.$message.success('操作成功!')
            this.$router.go(-1)
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    async getPrice(id) {
      this.priceData = {}
      const res = await this.$axios.get('/company/admin/notarization/supplier/queryByCompanyId', {
        params: {
          companyId: id,
        },
      })
      if (res.success && res.data) {
        this.priceData = res.data
        this.$nextTick(() => {
          this.safeSetFieldsValue$t(this.form, res.data)
        })
        // this.$nextTick(() => {
        //   this.form.setFieldsValue({
        //     duplicationPrice: res.data.duplicationPrice,
        //     expressPrice: res.data.expressPrice,
        //     notarizationPrice: res.data.notarizationPrice,
        //     ordinaryDuration: res.data.ordinaryDuration,
        //     servicePrice: res.data.servicePrice,
        //     superDuration: res.data.superDuration,
        //     urgentDuration: res.data.urgentDuration
        //   })
        // })
      }
    },
    async loadById(id) {
      const res = await this.$axios.get('/company/admin/company/queryByCompanyId', {
        params: {
          companyId: id,
        },
      })
      const companyData = res.data
      if (res.data.supplierInfoDto && res.data.supplierInfoDto.businessType) {
        res.data.businessType = res.data.supplierInfoDto.businessType
      }
      this.companyData = companyData
      const fields = {
        ...companyData,
      }

      if (companyData.contractStartDate) {
        fields.contractStartDate = this.$moment(companyData.contractStartDate)
      }
      if (companyData.contractEndDate) {
        fields.contractEndDate = this.$moment(companyData.contractEndDate)
      }
      if (companyData.supplierInfoDto) {
        this.address.province = companyData.supplierInfoDto.province
        this.address.city = companyData.supplierInfoDto.city
        this.address.region = companyData.supplierInfoDto.region
        fields.address = companyData.supplierInfoDto.address
        fields.phoneNumber = companyData.supplierInfoDto.phoneNumber
        fields.person = companyData.supplierInfoDto.person
        fields.region = companyData.supplierInfoDto.region
        this.supplierId = companyData.supplierInfoDto.supplierId
        fields.contractEndDate = this.$moment(companyData.contractEndDate)
      }
      this.safeSetFieldsValue$t(this.form, fields)
    },
  },
  mounted() {
    console.log('加载时间：2')
    const id = this.$route.query.companyId
    if (id) {
      this.loadById(id)
      this.getPrice(id)
    }
  },
}
</script>

<style lang="less"></style>
